<template>
  <div>
    <div style="height: 22px;" class="hidden-md-and-up"></div>
  <SmallHeader :title="box.title" :cat="box.cat"></SmallHeader>
    <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3 mt-3">
      <v-card style="border-radius: 3px; border: 1px solid lightgray;" class="elevation-0">
    <v-layout
      text-xs-left
      wrap
    >


      <v-flex md8 xs12>



        <v-card-text style="height: 100%;">
          <v-layout align-space-around justify-space-around column >
            <v-flex>
              <div
              v-for="(page, i) in box.pages"
              :key="'page-'+i"
              >
                <div><h3 class=" mb-2" :class="i === 0 ? 'headline' : 'display mt-4'">{{page.title}}</h3></div>

                <div class="body-2">

                  {{page.text}}</div>
                <div class="body-1 pt-1 ">                  <v-card ripple class="mt-1 mr-3 mb-1" @click="updateImage(i)" style="width: 200px; line-height: 0; float: left; cursor: pointer;"><img style="width: 200px;"
                                                                   :src="page.image ? require('@/assets/'+page.image) : require('@/assets/'+'transparent.png')"
                                                                   aspect-ratio="1.5"/></v-card>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Volutpat maecenas volutpat blandit aliquam. Magna sit amet purus gravida quis blandit turpis cursus. Tellus elementum sagittis vitae et leo duis. Dignissim cras tincidunt lobortis feugiat. Sed risus ultricies tristique nulla aliquet enim tortor at. Enim neque volutpat ac tincidunt vitae. Commodo quis imperdiet massa tincidunt nunc. Sit amet mattis vulputate enim nulla aliquet porttitor. Enim facilisis gravida neque convallis a cras semper auctor neque. Amet mattis vulputate enim nulla aliquet. Facilisi nullam vehicula ipsum a arcu. Parturient montes nascetur ridiculus mus. Mi in nulla posuere sollicitudin aliquam ultrices sagittis orci a. Velit dignissim sodales ut eu sem integer vitae justo. Faucibus pulvinar elementum integer enim neque volutpat ac tincidunt. Sagittis nisl rhoncus mattis rhoncus. Ut tellus elementum sagittis vitae et leo duis ut.
                <p class="mt-1 mb-0">Amet dictum sit amet justo donec enim. Dignissim enim sit amet venenatis urna cursus eget nunc. Non arcu risus quis varius quam quisque. Velit scelerisque in dictum non consectetur a erat nam. Sed euismod nisi porta lorem. Congue eu consequat ac felis. Nisi est sit amet facilisis magna etiam. Lorem dolor sed viverra ipsum nunc. Elementum tempus egestas sed sed risus. Ultricies tristique nulla aliquet enim tortor at auctor. Suspendisse interdum consectetur libero id faucibus nisl tincidunt. Iaculis urna id volutpat lacus laoreet non curabitur gravida arcu. Lorem donec massa sapien faucibus et molestie. Fringilla urna porttitor rhoncus dolor purus. Ultrices tincidunt arcu non sodales neque sodales ut. Scelerisque viverra mauris in aliquam sem fringilla ut.</p>
                  <p class="mt-1">Suspendisse interdum consectetur libero id faucibus nisl tincidunt. Viverra maecenas accumsan lacus vel facilisis volutpat est. In cursus turpis massa tincidunt dui ut ornare. Suspendisse interdum consectetur libero id faucibus nisl tincidunt eget. Risus pretium quam vulputate dignissim suspendisse. Rhoncus dolor purus non enim praesent elementum. Etiam dignissim diam quis enim. Nibh tellus molestie nunc non. Faucibus purus in massa tempor nec feugiat nisl pretium. Sit amet massa vitae tortor condimentum. Neque sodales ut etiam sit amet. Tristique senectus et netus et malesuada fames. Convallis convallis tellus id interdum velit laoreet id donec ultrices. Luctus venenatis lectus magna fringilla urna porttitor. Malesuada fames ac turpis egestas integer eget. Viverra nam libero justo laoreet sit amet cursus sit. Cras pulvinar mattis nunc sed blandit libero volutpat.</p>
                </div>
              </div>

            </v-flex>
          </v-layout>
        </v-card-text>


      </v-flex>

      <v-flex md4 xs12 class="grey lighten-2">
        <v-img
               :src="require('@/assets/'+image)"
               aspect-ratio="1.61803398875"
        ></v-img>

        <div class="pa-2 text-xs-right" style="margin-top:-44px; opacity: 0.5;" >
          <v-btn small dark round depressed  class="ma-0" color="grey darken-4">
            download image
            <v-icon small right light>mdi-download</v-icon>
          </v-btn>
        </div>

        <v-card-text  class="pl-3 pr-3 pt-2 pb-0" >
          <p class="pt-1 pb-1 ma-0 body-2" >Lorem ipsum dolor sit amet</p>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-0 pb-0" >
          <p class="pt-1 pb-1 ma-0 caption" >At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.</p>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-0" >
          <p class="pt-1 pb-1 ma-0 caption font-weight-light " >Image credits: AEI/MildeMarketing</p>
        </v-card-text>

        <v-card-text  class="pl-3 pr-3 pt-2 pb-0" >
          <p class="pt-1 pb-1 ma-0 body-2" >Documents</p>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-1 pb-1" >
          <v-btn small dark round outline  class="ma-0" color="grey darken-4" style="width: 100%;">
            White paper (2.6 MB)
            <v-icon small right light>mdi-download</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-1 pb-1" >
          <v-btn small dark round outline  class="ma-0" color="grey darken-4" style="width: 100%;">
            Noise sources (1.7 MB)
            <v-icon small right light>mdi-download</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-1 pb-1" >
          <v-btn small dark round outline  class="ma-0" color="grey darken-4" style="width: 100%;">
            Technical designs (12.1 MB)
            <v-icon small right light>mdi-download</v-icon>
          </v-btn>
        </v-card-text>


        <v-card-text  class="pl-3 pr-3 pt-3 pb-1" >
          <p class="pt-1 pb-1 ma-0 body-2" >External links</p>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-0 pb-2">
          <a href="#" class="red--text darken-1" style="text-decoration: none;"><v-icon small>mdi-link</v-icon> LISA Mission (ESA)</a>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-0 pb-2">
          <a href="#" class="red--text darken-1" style="text-decoration: none;"><v-icon small>mdi-link</v-icon> LISA Mission (NASA)</a>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-0 pb-2">
          <a href="#" class="red--text darken-1" style="text-decoration: none;"><v-icon small>mdi-link</v-icon> Gravitational Wave Observatory Designer</a>
        </v-card-text>
        <v-card-text  class="pl-3 pr-3 pt-0 pb-2">
          <a href="#" class="red--text darken-1" style="text-decoration: none;"><v-icon small>mdi-link</v-icon> Gravitational Wave Ping Pong</a>
        </v-card-text>

      </v-flex>



    </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>

import SmallHeader from '../components/SmallHeader'

export default {
  components: {
    SmallHeader
  },
  data () {
    return {
      image: 'transparent.png',
      tabs: 0
    }
  },
  props: {
    box: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    updateImage (i) {
      if (this.box.pages[i]) {
        if (this.box.pages[i].image) {
          this.image = this.box.pages[i].image
        } else {
          this.image = 'transparent.png'
        }
      }
    }
  },
  mounted () {
    this.updateImage(0)
  }
}
</script>
